module.exports = __webpack_public_path__ + "static/media/ios-help.711abf96.svg";